import { SingleTierTax } from './../../classes/singleTierTax/singleTierTax';
import { rates } from './config';
import { AlgemeneHeffingsKortingConfig } from './interface';

export class AlgemeneHeffingsKorting {
    
    tax: number;
    
    constructor(data: AlgemeneHeffingsKortingConfig) {
        this.tax = new SingleTierTax(rates[data.year], data.income).tax;
    }
    
}
